import { trpc } from "@/lib/trpc";

export const useUserGroupsQuery = (params?: { page?: number; per_page?: number; filter?: { search?: string } }) =>
    trpc.userGroups.findMany.useQuery(params || { page: 1, per_page: 10 });

export const useUserGroupsInfiniteQuery = (params?: { 
    limit?: number; 
    filter?: { search?: string } 
}) => {
    return trpc.userGroups.findManyInfinite.useInfiniteQuery(
        {
            limit: params?.limit || 20,
            filter: params?.filter,
        },
        {
            getNextPageParam: (lastPage) => lastPage.nextCursor,
        }
    );
};

export const useUserGroupQuery = (id: string, enabled: boolean = true) =>
    trpc.userGroups.findOne.useQuery(id, { enabled });

export const useUserGroupWithConnectionsQuery = (id: string, enabled: boolean = true) =>
    trpc.userGroups.findOneWithConnections.useQuery(id, { enabled });

export const useAgentConnectionsForGroupQuery = (userGroupId: string, enabled: boolean = true) =>
    trpc.userGroups.getAgentConnectionsForGroup.useQuery(userGroupId, { enabled });

export const useUsersForGroupQuery = (userGroupId: string, enabled: boolean = true) =>
    trpc.userGroups.getUsersForGroup.useQuery(userGroupId, { enabled });

export const useUserGroupWithUsersQuery = (id: string, enabled: boolean = true) =>
    trpc.userGroups.findOneWithUsers.useQuery(id, { enabled });

// IDP Group Import queries
export const useAvailableIDPGroupsQuery = (enabled: boolean = true) =>
    trpc.userGroups.getAvailableIDPGroups.useQuery(undefined, { enabled });

export const usePreviewGroupImportQuery = (groupIds: string[], enabled: boolean = false) =>
    trpc.userGroups.previewGroupImport.useQuery({ groupIds }, { enabled });
